enum TipoConvenioFaixa {
    Cliente = 0,
    Veterinario = 1
}

export default TipoConvenioFaixa;